import React from 'react'

export const House = () => {
    return ( <div className="house" onClick={() => document.querySelector('aside').scrollIntoView()}>
        <svg style={{ height: '100%', background: 'rgb(255, 255, 255)' }} width="100px" height="100px">
            <g style={{ transformOrigin: '50% 50%', transform: 'rotate(0deg) scale(1, 1)' }}>
                <g>
                    <g>
                        <g style={{ transformOrigin: '34.5px 34.5px', transform: 'scale(0.95)', animation: '2.77778s linear -2.15278s infinite normal forwards running  breath-87d517d3-5e25-4177-9447-c3c566fba67c' }}>
                            <circle fill="#333" r="40" cy="50" cx="50" style={{fill: 'rgb(92, 98, 197)'}}></circle>
                        </g>
                    </g>
                    <g>
                        <g style={{transformOrigin: '50px 50px', transform: 'scale(0.95)', animation: '0.636943s linear -0.636943s infinite normal forwards running  breath-87d517d3-5e25-4177-9447-c3c566fba67c'}}>
                            <path d="M72.5 47.97L50 29.026 27.5 47.97h8.192v19.004h10.073V53.732h8.47v13.242h10.073V47.97z" fill="#e0e0e0" style={{fill: 'rgb(255, 255, 255)'}}></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </div>)
}
